import * as actions$1 from './CreateAccount/actions.js';
export { actions$1 as CreateAccountActions };
import * as actions$2 from './Login/actions.js';
export { actions$2 as LoginActions };
import * as actions$3 from './Logout/actions.js';
export { actions$3 as LogoutActions };
import * as actions$4 from './OptIns/actions.js';
export { actions$4 as OptInsActions };
import * as actions$5 from './ResetPassword/actions.js';
export { actions$5 as ResetPasswordActions };
import * as actions$6 from './UserData/actions.js';
export { actions$6 as UserDataActions };

const INIT = 'auth/init';
const GOTO = 'auth/goto';
const init = (payload)=>({
        type: INIT,
        payload
    })
;
const goto = (payload)=>({
        type: GOTO,
        payload
    })
;

export { GOTO, INIT, goto, init };
//# sourceMappingURL=actions.js.map
